import React from 'react';
import { withRouter } from 'react-router';
import Navbar from './../Navbar/navbar.jsx';
import Navigation from './../Navigation/navigation.jsx';
import { isLogin } from './../../utils/authentication.js';
import { Form, Button, Table, ListGroup } from 'react-bootstrap';
import _ from 'lodash'
import Moment from "moment";
import { connect } from "react-redux";
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import 'react-bootstrap-typeahead/css/Typeahead.min.css';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import actions from './../../store/Actions/index.js';
import MeUploadForm from './MeUploadForm.js'


import {
    BACKEND_URL
} from '../../config.js';


class MeUploader extends React.PureComponent {
  state = {
    isOptionsLoadin: false,
    data: [],
    show: false,
    selectedData: null
  };

  componentWillMount() {

    if(!isLogin()){
        this.props.history.push({
            pathname:"/login"
        });
    }

    this.setState({isOptionsLoadin: true})
    this.getAllList()
  }

  getAllList() {
    axios.get(
      `${BACKEND_URL}/v1/explore/GetMeUpload`,
      {
        headers: {
            token: localStorage.getItem("token")
        }
      }
    ).then((res) => {
      this.setState({data: res.data })
      this.setState({isOptionsLoadin: false})
    }).catch((err) => {
      this.setState({isOptionsLoadin: false})
    })
  }



  // getAllList = ()=> {
  //   let reportId = '5dfa0054b02f1908730aa18f'
  //   this.props.dispatch(actions.getEditor(reportId))
  // }

  handleChange =(e)=> {
    this.setState({reportId: e.target.value})
    this.props.dispatch(actions.getEditor(e.target.value))
  }

  onEditModal = ()=> {
    this.setState({show: true})
  }

  onEditClose = () => {
    this.setState({selectedData: null, show: false})
  }


  handleSubmit = async (data)=> {
    let conf = confirm("Are you sure you want to update?")
    if(conf) {
      await this.props.dispatch(actions.MeUpload(data))
      this.getAllList()
      this.setState({show: false})
    }
  }

  onDelete = (id, name)=> {
    let conf = confirm("Are you sure you want to delete " + name + " ?")
    if(conf && id) {
      axios.post(
        `${BACKEND_URL}/v1/explore/DeleteMeUpload`, { id: id },
        {
            headers: {
                token: localStorage.getItem("token")
            }
        }
      ).then((res) => {
        this.getAllList()
        alert("Deleted Successfully!")
      }).catch((err) => {
          console.log(err)
      })
    }

  }

  render() {
     const { isOptionsLoadin, data, selectedData } = this.state;

    return (
      <div>
        <div className="col-md-12 topbar">
            <Navbar />
        </div>

        <main role="main" className="p-5">
          <div className="my-3 p-3 bg-white rounded shadow-sm">
            <h6 className="border-bottom border-gray pb-2 mb-0">BIS Workspace - ME Data - Top {data && data && data.length}</h6>
            <div className="card">

            {!isOptionsLoadin && data ?
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>Table Name</th>
                    <th>SKU</th>
                    <th><button type="button" className="btn btn-primary" onClick={()=> this.onEditModal()}>Upload New Sheet</button></th>
                  </tr>
                </thead>
                <tbody>
                {!isOptionsLoadin && data && data.map((o, index)=>
                  <tr key={index}>
                    <td>{o.tablename}</td>
                    <td>{o.id}</td>
                    <td>
                      <button type="button" className="btn btn-warning ml-2" onClick={()=> this.onDelete(o._id, o.tablename)}>Delete</button>
                    </td>
                  </tr>
                )}

                { data && data.length == 0 &&
                  <tr>
                    <td colSpan="3">No Results Found</td>
                  </tr>
                }
                </tbody>
              </Table> : 
              <div className="p-1">Loading Please Wait....</div>
              }


              <Modal size="lg" show={this.state.show} onHide={this.onEditClose} className="modal-size">
                  <Modal.Header closeButton>
                      <div className="row col-md-12">
                          <Modal.Title className="col-md-6 heading-details">Upload ME File</Modal.Title>
                      </div>   
                  </Modal.Header>
                  <Modal.Body className="modal-body">
                      <MeUploadForm initialValues={selectedData} onSubmit={this.handleSubmit}  />
                  </Modal.Body>
              </Modal>
              

             {/* { !isOptionsLoadin && data && data.companies ? 
                  <ImEditorForm initialValues={{ companies: data.companies}} onSubmit={this.handleSubmit}  /> 
                  :
                  <div className="p-1">Loading Please Wait....</div>
              }*/}

            </div>
          </div>
        </main>
      </div>
    );
  }
}


function mapStateToProps(state){
    return { }
}

export default withRouter(connect(
  mapStateToProps
)(MeUploader))





// WEBPACK FOOTER //
// ./src/components/Insights/MeUploader.js